import { useEffect, useRef } from 'react';
import { logNewRelicAction } from '../utils/logNewRelicAction';

export const usePageView = ({ userInfoLoaded, pathname, userId }) => {
  const previousUrl = useRef('');
  useEffect(() => {
    if (userInfoLoaded) {
      window?.optimoveSDK?.API?.setPageVisit?.(
        pathname,
        pathname,
        pathname.split?.('/')?.[1] || 'home',
        userId?.toString() || undefined
      );
    }
  }, [pathname, userId, userInfoLoaded]);

  useEffect(() => {
    if (userInfoLoaded) {
      logNewRelicAction('PAGE_VIEW', {
        pathname,
        previousUrl: previousUrl.current,
        isInitial: !previousUrl.current
      });
      previousUrl.current = pathname;
    }
  }, [pathname, userInfoLoaded]);
};
